"use client";

import { c as _c } from "react/compiler-runtime";
import { useCallback, useRef, useState } from "react";
interface DragHandleProps {
  onDrag: (offset: number) => void;
  onClose: () => void;
  className?: string;
}
export function DragHandle(t0) {
  const $ = _c(26);
  const {
    onDrag,
    onClose,
    className
  } = t0;
  const [isDragging, setIsDragging] = useState(false);
  const startY = useRef(0);
  const currentDragY = useRef(0);
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = e => {
      e.stopPropagation();
      startY.current = e.touches[0].clientY;
      currentDragY.current = 0;
      setIsDragging(true);
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const handleTouchStart = t1;
  let t2;
  if ($[1] !== isDragging || $[2] !== onDrag) {
    t2 = e_0 => {
      if (!isDragging) {
        return;
      }
      e_0.stopPropagation();
      const currentY = e_0.touches[0].clientY;
      const deltaY = currentY - startY.current;
      if (deltaY > 0) {
        e_0.preventDefault();
        currentDragY.current = deltaY;
        onDrag(deltaY);
      }
    };
    $[1] = isDragging;
    $[2] = onDrag;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  const handleTouchMove = t2;
  let t3;
  if ($[4] !== onClose || $[5] !== onDrag) {
    t3 = e_1 => {
      e_1.stopPropagation();
      setIsDragging(false);
      if (currentDragY.current > 100) {
        onClose();
      } else {
        onDrag(0);
      }
      currentDragY.current = 0;
    };
    $[4] = onClose;
    $[5] = onDrag;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  const handleTouchEnd = t3;
  let t4;
  if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = e_2 => {
      e_2.stopPropagation();
      e_2.preventDefault();
      startY.current = e_2.clientY;
      currentDragY.current = 0;
      setIsDragging(true);
    };
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  const handleMouseDown = t4;
  let t5;
  if ($[8] !== isDragging || $[9] !== onDrag) {
    t5 = e_3 => {
      if (!isDragging) {
        return;
      }
      e_3.stopPropagation();
      e_3.preventDefault();
      const deltaY_0 = e_3.clientY - startY.current;
      if (deltaY_0 > 0) {
        currentDragY.current = deltaY_0;
        onDrag(deltaY_0);
      }
    };
    $[8] = isDragging;
    $[9] = onDrag;
    $[10] = t5;
  } else {
    t5 = $[10];
  }
  const handleMouseMove = t5;
  let t6;
  if ($[11] !== isDragging || $[12] !== onClose || $[13] !== onDrag) {
    t6 = e_4 => {
      if (!isDragging) {
        return;
      }
      e_4.stopPropagation();
      setIsDragging(false);
      if (currentDragY.current > 100) {
        onClose();
      } else {
        onDrag(0);
      }
      currentDragY.current = 0;
    };
    $[11] = isDragging;
    $[12] = onClose;
    $[13] = onDrag;
    $[14] = t6;
  } else {
    t6 = $[14];
  }
  const handleMouseUp = t6;
  let t7;
  if ($[15] !== isDragging || $[16] !== onDrag) {
    t7 = e_5 => {
      if (isDragging) {
        e_5.stopPropagation();
        setIsDragging(false);
        onDrag(0);
        currentDragY.current = 0;
      }
    };
    $[15] = isDragging;
    $[16] = onDrag;
    $[17] = t7;
  } else {
    t7 = $[17];
  }
  const handleMouseLeave = t7;
  const t8 = `flex justify-center p-2 flex-shrink-0 cursor-grab active:cursor-grabbing select-none touch-none ${className || ""}`;
  let t9;
  if ($[18] === Symbol.for("react.memo_cache_sentinel")) {
    t9 = <div className="w-8 h-1 bg-gray-300 rounded-full" />;
    $[18] = t9;
  } else {
    t9 = $[18];
  }
  let t10;
  if ($[19] !== handleMouseLeave || $[20] !== handleMouseMove || $[21] !== handleMouseUp || $[22] !== handleTouchEnd || $[23] !== handleTouchMove || $[24] !== t8) {
    t10 = <div className={t8} onTouchStart={handleTouchStart} onTouchMove={handleTouchMove} onTouchEnd={handleTouchEnd} onMouseDown={handleMouseDown} onMouseMove={handleMouseMove} onMouseUp={handleMouseUp} onMouseLeave={handleMouseLeave}>{t9}</div>;
    $[19] = handleMouseLeave;
    $[20] = handleMouseMove;
    $[21] = handleMouseUp;
    $[22] = handleTouchEnd;
    $[23] = handleTouchMove;
    $[24] = t8;
    $[25] = t10;
  } else {
    t10 = $[25];
  }
  return t10;
}